import { render } from "./SessionsV2View.vue?vue&type=template&id=edcdc036&scoped=true"
import script from "./SessionsV2View.vue?vue&type=script&lang=js"
export * from "./SessionsV2View.vue?vue&type=script&lang=js"

import "./SessionsV2View.vue?vue&type=style&index=0&id=edcdc036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edcdc036"]])

export default __exports__